
import { BaseVue } from "@newview/base-web";
import { comForm, customModal} from "@newview/ui";
import { Component, Watch,Prop } from "vue-property-decorator";
import {
  UserInforApi
} from '@newview/system-api' 
@Component({
  name: "updatePwd",
  components: {
    comForm,
    customModal
  },
})
export default class updatePwd extends BaseVue {  
  userInforApi: UserInforApi = new UserInforApi()
  IsShowMusk=true //是否取消遮罩层
  pwdMadel = false;
  editPwdClosable=true;
  changePwdItemData: any = [
    {
      label: '原密码',
      type: 'input',
      inputType: 'password',
      prop: 'oldPassword',
      model: 'oldPassword',
      password: true,
      col: 24,
      blurEvent: function () {},
    },

    {
      label: '新密码',
      type: 'input',
      inputType: 'password',
      prop: 'newPassword',
      model: 'newPassword',
      placeholder:
        '密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到30位！',
      col: 24,
      password: true,
      blurEvent: function () {},
      tips: '密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到30位！',
    },
    {
      label: '确认密码',
      type: 'input',
      inputType: 'password',
      prop: 'confirmPassWord',
      model: 'confirmPassWord',
      password: true,
      col: 24,
      blurEvent: function () {},
    },
  ]
  changePwdModel: any = {
    checkCode: '123',
    oldPassword: '',
    newPassword: '',
    confirmPassWord: '',
    userName: this.$globalData_Plms.localUser.userName,
    id: this.$globalData_Plms.localUser.id,
  }
  changePwdRuleValidate: any = {
    oldPassword: [
      { required: true, message: '原密码不能为空', trigger: 'blur' },
    ],
    newPassword: [
      {
        required: true,
        message:
          '密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到30位！',
        trigger: 'change',
      },
      {
        pattern:
          /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,30}$/,
        message:
          '密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到30位！',
      },
    ],
    confirmPassWord: [
      { required: true, message: '确认密码不能为空', trigger: 'blur' },
    ],
  }
  IsShowWarning=false
  changePwdModal = false
  changePwdIsClose = true
  tipMsg = '您的密码已过期，'

  created() {   
    // 判断密码是否过期，强制更新密码
    let pwdExpiredDate = new Date(this.$globalData_Plms.localUser.expiredDate).getTime();
    let isLow:any = sessionStorage.getItem("isLow");
    if ((new Date()).getTime() > pwdExpiredDate || isLow==1) {
      if(isLow==1) this.tipMsg = '你的密码安全性太低，'
      setTimeout(()=>{
          this.changePwdModal = true
         this.changePwdIsClose = false

      },180);

    }
  }
  mounted() {     
  }
  updatePwdFun(){  
    this.changePwdModal=true;
    this.changePwdModel = {
      checkCode: '123',
      oldPassword: '',
      newPassword: '',
      confirmPassWord: '',
      userName: this.$globalData_Plms.localUser.userName,
      id: this.$globalData_Plms.localUser.id,
    }  
  }
  changePwdOp() {    //修改密码操作
    (this.$refs['changePwdForm'] as any).validate((valid, datas) => {
      if (valid) {
        if(this.changePwdModel.newPassword != this.changePwdModel.confirmPassWord) {
          this.tipMessage('请确认两次密码输入一致')
          return
        }
        let updataPwdData = JSON.parse(JSON.stringify(this.changePwdModel))
        updataPwdData.oldPassword = this.base64encode(updataPwdData.oldPassword)
        updataPwdData.userName = this.base64encode(updataPwdData.userName)
        updataPwdData.newPassword = this.base64encode(updataPwdData.newPassword)
        updataPwdData.confirmPassWord = this.base64encode(
          updataPwdData.confirmPassWord
        )
        updataPwdData.id = this.$globalData_Plms.localUser.id
        this.userInforApi.updatePassword(updataPwdData).then((res) => {
          if(res.code == 200) { 
            setTimeout(()=>{
              this.changePwdModal = false;
                  this.alert(
                  '密码已修改成功，将为您自动跳转至登录页',
                  () => { 
                    localStorage.clear()
                    sessionStorage.clear()
                    this.$router.replace('/')
                  },
                  'success'
                )
            },560);
           
          } else {
            this.error(res.msg)
          }
        })
      }
    })
  }
}
